export { CouponTemplate } from "./CouponTemplate";
export { useCouponData } from "./hooks";
